import React from "react";
import Dropdown from "../../Dropdowns/Dropdown"; // Adjust path as needed

const PositionTabContent = ({
  dataLoading,
  dataError,
  parsedData,
  company,
  setCompany,
  team,
  setTeam,
  department,
  setDepartment,
  division,
  setDivision,
  position,
  setPosition,
  handleDropdownClick,
}) => {
  // Display loading state if data is being fetched
  if (dataLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <svg
            className="animate-spin h-8 w-8 text-blue-600 mx-auto mb-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <p className="text-gray-600">Загрузка данных...</p>
        </div>
      </div>
    );
  }

  // Display error state if there was an error fetching data
  if (dataError) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center text-red-600">
          <p className="font-medium mb-2">Ошибка загрузки данных</p>
          <p className="text-sm">{dataError}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-6">
      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Компания*
          </label>
          <div onClick={handleDropdownClick}>
            <Dropdown
              options={parsedData.companies}
              selectedOption={company}
              onChange={(selectedCompany) => {
                setCompany(selectedCompany);
              }}
              placeholder="Выберите компанию"
            />
          </div>
          {!company && (
            <p className="text-xs text-red-500 mt-1">
              Это поле обязательно для заполнения
            </p>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Команда
          </label>
          <div onClick={handleDropdownClick}>
            <Dropdown
              options={parsedData.teams}
              selectedOption={team}
              onChange={(selectedTeam) => {
                setTeam(selectedTeam);
              }}
              placeholder="Выберите команду"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Отдел
          </label>
          <div onClick={handleDropdownClick}>
            <Dropdown
              options={parsedData.departments}
              selectedOption={department}
              onChange={(selectedDepartment) => {
                setDepartment(selectedDepartment);
              }}
              placeholder="Выберите отдел"
            />
          </div>
        </div>
      </div>

      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Подразделение
          </label>
          <div onClick={handleDropdownClick}>
            <Dropdown
              options={parsedData.divisions}
              selectedOption={division}
              onChange={(selectedDivision) => {
                setDivision(selectedDivision);
              }}
              placeholder="Выберите подразделение"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Должность
          </label>
          <div onClick={handleDropdownClick}>
            <Dropdown
              options={parsedData.positions}
              selectedOption={position}
              onChange={(selectedPosition) => {
                setPosition(selectedPosition);
              }}
              placeholder="Выберите должность"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PositionTabContent;
